import us from '../../defines';

/**
 * This class assists in manipulating the state of viewport overlays when capturing a snapshot.
 */
export function ViewportHelper (viewport) {
  const $vpContainer = viewport.vpDivGet('outer');
  const $vpInner = viewport.vpDivGet();
  const $viewportItems = $vpContainer.find('div.us_overlay, div.us_superoverlay').filter(':visible');
  const $uScopeItems = $(us.idHashROOT).find(`#${us.idTOPTOOLBARV}, .uscope-dialog`).filter(':visible');
  let transform;

  this.hideOverlays = () => {
    $viewportItems.hide();
    $uScopeItems.hide();
    transform = $vpInner.css('transform');
    $vpInner.css('transform', '');
  };

  this.showOverlays = () => {
    $viewportItems.show();
    $uScopeItems.show();
    $vpInner.css('transform', transform);
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/ViewportHelper.js